export const state = () => ({
  billingInfo: {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    addressLine1: '',
    addressLine2: '',
    zipCode: '',
    city: '',
    state: '',
    country: '',
    countryCode: '',
    company: '',
  },
  promoCodeInfo: {
    codes: [],
    code: '',
  },
})

export const mutations = {
  updateBillingInfo(state, payload) {
    state.billingInfo[payload.fieldName] = payload.value
  },
  setPromoCodeInfo(state, payload) {
    state.promoCodeInfo.codes = payload.codes
    state.promoCodeInfo.code = payload.code
  },
}

export const actions = {}
